<template>
<div>
  <div class="gallery-grid mt-8">
      <img class="image" v-for="(image, i) in product?.formatted_images?.images" :key="i" :src="getBrandImageUrl(image)"  @click="openLightbox(i)">
      <vue-easy-lightbox
        :visible="visible"
        :imgs="product?.formatted_images?.images?.map(img => getBrandImageUrl(img))"
        :index="index"
        @hide="handleHide"
      />
       
  </div>

  </div>
</template>
<script setup>
import VueEasyLightbox from 'vue-easy-lightbox';
import { ref, defineProps } from 'vue';
import { getBrandImageUrl } from '@/js/utils/common.js';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
  show_product_details: {
    type: Boolean,
    required: true,
  },
});

const visible = ref(false);
const index = ref(0);
const APIURL = import.meta.env.VITE_API_URL;

const openLightbox = (i) => {
  index.value = i;
  visible.value = true;
};

const handleHide = () => {
  visible.value = false;
};

</script>
<style scoped>
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 200px);
  gap: 20px;
}
.image {
  width: 200px;
  height: 200px;
  object-fit: contain;
  cursor: pointer;
  border-radius: 3px;
}

@media (max-width: 600px) {
  .gallery-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
    width: 100%;
  }
  .image {
    width: 100%;
    height: auto;
    aspect-ratio: 1;
  }
}
</style>
